import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import { useNavigate } from "react-router-dom";
import PlaceholderDiscountText from "./PlaceholderDiscountText";

const AddPromoCodeMobile = ({
  value,
  onChange,
  onApply,
  onRemove,
  cart,
  userType,
  onContinueShopping,
  spinpromo,
  isPlaceholder,
  isRemove,
  setIsRemove,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (value === "") {
    } else {
      onApply();
    }
  };

  const handleRemove = () => {
    setIsRemove(!isRemove);
    onRemove();
  };

  const handleLoginSignUp = () => {
    navigate("/auth/login");
    localStorage.setItem("cartId", cart._id);
    localStorage.setItem("shouldContinue", "accept");
  };
  return (
    <PromoCodeContainer>
      <PromoCodeTitle>{Text.promoCode}</PromoCodeTitle>
      {userType == "guest" ? (
        <GuestPromoLabel>
          <span onClick={() => handleLoginSignUp()}>Login or SignUp</span> to
          Access Promocode and Discounts!
        </GuestPromoLabel>
      ) : null}
      <ApplyPromoContainer>
        {isPlaceholder ? (
          <PlaceholderDiscountText discountDetails={cart} />
        ) : (
          <TextInput
            value={value}
            placeholder="Enter Your Promocode"
            onChange={onChange}
            disabled={userType == "guest" || spinpromo}
          />
        )}
        <PromoButtonContainer disabled={userType == "guest" || value === ""}>
          <Button
            fontSize="0.9rem"
            label={isRemove ? "Remove" : "Apply Coupon"}
            width="100%"
            padding="0.8rem 1rem"
            disabled={userType == "guest" || value === "" || spinpromo}
            borderRadius="0 0.5rem 0.5rem 0"
            variant="filled"
            onClick={isRemove ? handleRemove : handleClick}
            backgroundColor={isRemove ? Colors.red : Colors.aqua}
          />
        </PromoButtonContainer>

        {/* <ApplyPromoBtn onClick={handleClick} entered={value !== ""}>
          <ApplyPromoText>{Text.applyCoupon}</ApplyPromoText>
        </ApplyPromoBtn> */}
      </ApplyPromoContainer>
      {/* {cart?.discountAmount > 0 && (
        <CouponSubTitle>Promo applied successfully</CouponSubTitle>
      )} */}
      {/* <AddPromoSubTitle>{Text.enterPromoCodeNote}</AddPromoSubTitle> */}
      {/* <ContinueButton onClick={onContinueShopping}>
        <ButtonTitle>{Text.continueShopping}</ButtonTitle>
      </ContinueButton> */}
    </PromoCodeContainer>
  );
};

const GuestPromoLabel = styled.div`
  margin-top: 1rem;
  text-align: center;
  padding: 0 2rem;
  > span {
    color: ${Colors.aqua};
  }
`;

const PromoCodeContainer = styled.div`
  display: none;
  @media only screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 7rem;
    align-items: flex-start;
    padding-left: 1rem;
    margin-bottom: 1rem;
    width: 90%;
  }
`;
const AddPromoTitle = styled.span`
  color: ${Colors.arsenic};
  font-size: 1rem;
  font-weight: 900;
`;
const AddPromoSubTitle = styled(AddPromoTitle)`
  color: ${Colors.approxGrey};
  font-size: 1rem;
  font-weight: 400;
  margin-top: 0.5rem;
`;

const CouponSubTitle = styled(AddPromoTitle)`
  color: ${Colors.aqua};
  font-size: 1rem;
  font-weight: 400;
  margin-top: 0.5rem;
`;
const ApplyPromoContainer = styled.div`
  border-radius: 12px;
  background: ${Colors.white};
  display: flex;
  margin-top: 0.6rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "default")};
  width: 100%;
`;
const PromoButtonContainer = styled.div`
  border: ${(props) =>
    props.disabled ? "none" : `0.5px solid ${Colors.rainbowGrey}`};
  border-radius: 0 0.5rem 0.5rem 0;
  display: flex;
  width: 45%;
`;
const TextInput = styled.input`
  display: flex;
  width: 55%;
  height: 100%;
  font-size: 0.9rem;
  border-radius: 12px 0px 0px 12px;
  border: 0.5px solid ${Colors.rainbowGrey};
  box-sizing: border-box;
  outline: none;
  padding: 1rem 0rem 1rem 1rem;

  &::placeholder {
    color: #373737;
    opacity: 0.2;
    font-size: 14px;
  }
  &:disabled {
    opacity: 0.4;
  }
`;
const ApplyPromoBtn = styled.div`
  width: 60%;
  height: 100%;
  border-radius: 0px 12px 12px 0px;
  box-sizing: border-box;
  background: ${(props) => (props.entered ? Colors.aqua : "grey")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const ApplyPromoText = styled.span`
  color: ${Colors.white};
  font-size: 1rem;
  font-weight: 700;
`;
const ContinueButton = styled.button`
  background: ${Colors.white};
  outline: none;
  display: flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid ${Colors.rainbowGrey};
  margin-top: 2rem;
  width: 65%;
  cursor: pointer;
`;
const ButtonTitle = styled.span`
  font-size: 1rem;
  font-weight: 900;
  text-align: center;
  color: ${Colors.arsenic};
`;
const PromoCodeTitle = styled.span`
  @media only screen and (max-width: 576px) {
    color: ${Colors.secondaryBlack};
    font-size: 1.125rem;
    font-weight: 700;
    width: 90%;
    // border: 1px solid red;
  }
`;
export default AddPromoCodeMobile;
